<template>
  <div>
    <discount-modification-list :record-only="true" />
  </div>
</template>

<script>
import discountModificationList from '@/views/finance/discountModificationAudit/list.vue'

export default {
  components: {
    discountModificationList
  }
}
</script>
